import { datadogLogs } from '@datadog/browser-logs';
import { Serializable } from '@scale/shared/types/utils';
import { DATADOG_CLIENT_TOKEN, SERVICE_NAME, STACK, NODE_ENV, IS_FEDERAL } from './constants';

const LOG_TO_DATADOG = DATADOG_CLIENT_TOKEN && !IS_FEDERAL && process.browser;

if (LOG_TO_DATADOG) {
  datadogLogs.init({
    env: NODE_ENV,
    clientToken: DATADOG_CLIENT_TOKEN,
    forwardErrorsToLogs: false,
    silentMultipleInit: true,
  });

  datadogLogs.setGlobalContextProperty('service', SERVICE_NAME);
  datadogLogs.setGlobalContextProperty('context.env.stack', STACK);
}

type LogContext = {
  [key: string]: Serializable;
};

type LogLevel = 'debug' | 'info' | 'warn' | 'error';
type TwoArgLogger = <T extends LogContext>(message: string, context?: T) => void;
type Logger = Record<'log' | LogLevel, TwoArgLogger>;

const customLogger: Logger = {
  log: (message: string, ...args: any[]) => {
    // eslint-disable-next-line no-console
    console.log(message, ...args);
    datadogLogs.logger.log(message, ...args);
  },
  debug: (message: string, ...args: any[]) => {
    // eslint-disable-next-line no-console
    console.debug(message, ...args);
    datadogLogs.logger.debug(message, ...args);
  },
  info: (message: string, ...args: any[]) => {
    // eslint-disable-next-line no-console
    console.info(message, ...args);
    datadogLogs.logger.info(message, ...args);
  },
  warn: (message: string, ...args: any[]) => {
    // eslint-disable-next-line no-console
    console.warn(message, ...args);
    datadogLogs.logger.warn(message, ...args);
  },
  error: (message: string, ...args: any[]) => {
    // eslint-disable-next-line no-console
    console.error(message, ...args);
    datadogLogs.logger.error(message, ...args);
  },
};

/** NOTE: the `debug` level doesn't seem to log to console in dev */
const logger = LOG_TO_DATADOG ? customLogger : (console as Logger);

/** @deprecated Prefer just using logger */
export const trackError = LOG_TO_DATADOG
  ? datadogLogs.logger.error.bind(datadogLogs.logger)
  : // eslint-disable-next-line no-console
    console.error.bind(console);

export default logger;
